module.exports = __webpack_public_path__ + "img/shop_icon.3a78acdf.png";